import { render, staticRenderFns } from "./Web3NetButton.vue?vue&type=template&id=32df7b08&"
import script from "./Web3NetButton.vue?vue&type=script&lang=js&"
export * from "./Web3NetButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports